




























import { Component, Vue } from "vue-property-decorator";
import FunctionGroupModel from "@/app/models/FunctionGroup";

@Component
export default class FunctionGroup extends Vue {
    functionGroups: FunctionGroupModel[] = [];

    async beforeMount() {
        const paginator = await FunctionGroupModel.index();

        // @ts-ignore
        this.functionGroups = paginator.data;
        this.$store.commit('auth/setFunctionGroup', null);
    }

    setFunctionGroup(functionGroup: FunctionGroupModel) {
        this.$store.commit('auth/setFunctionGroup', functionGroup);

        this.$router.replace({ name: ['ADMIN', 'SUPER_ADMIN'].includes(this.me.role as string) ? 'divisions.index' : 'dashboard' });
    }

    async logout() {
        this.$set(this.$root, 'user', {});

        await this.$store.dispatch('auth/logout');
        await this.$router.replace({ name: 'login' });
    }
}
